export class SupplierId {
  constructor(private value: string) {}

  rawValue(): string {
    return this.value;
  }

  private SUPPLIER_ID_ASKUL = 'P00001';
  isAskul(): boolean {
    return this.value === this.SUPPLIER_ID_ASKUL;
  }
}
